import clickShow from "./clickShow"
const com = clickShow
//注册组件
const install = function (Vue){
    
    Vue.component(clickshow, clickShow)
    
}

export default install